import Joi from 'joi';

/**
 * Billing payload on tenant create. `trialStartsAt` and `meteringStartsAt`
 * are optional ISO-8601 instants; null is allowed. Provider customer ids are
 * not on this schema.
 */
export const createTenantBillingSchema = () =>
  Joi.object({
    enableMetering: Joi.boolean().optional(),
    trialStartsAt: Joi.string().isoDate().optional().allow(null),
    meteringStartsAt: Joi.string().isoDate().optional().allow(null),
  });
